import { render, staticRenderFns } from "./JsonLogicEditor.vue?vue&type=template&id=16083144&"
import script from "./JsonLogicEditor.vue?vue&type=script&lang=js&"
export * from "./JsonLogicEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports